export default __webpack_public_path__ + "static/media/Installation 4.cbaefb9c.jpg";